import { LayoutType } from '../../types/LayoutType';
import { ComponentType } from 'react';

class Layout {
  key: string;
  name: string;
  path: string;
  component: ComponentType;

  requiresAuth: boolean;
  requiresAdmin: boolean;

  constructor(route: LayoutType) {
    const {
      path,
      name,
      component,

      requiresAuth,
      requiresAdmin,
    } = route;
    this.name = name;
    this.key = name.replace(/ /g, '');
    this.path = path;
    this.component = component;

    this.requiresAuth = requiresAuth === false ? false : true;
    this.requiresAdmin = requiresAdmin || false;
  }
}

export default (route: LayoutType): Layout => new Layout(route);
